import React, {useEffect} from 'react'
import SEModalsResumenControl from './Components/ResumenFactura/Modals/SEModalsResumenControl'
import SEEncabezado from './Components/SEEncabezado'
import SEDocumentoTributario from './Components/ResumenFactura/SEDocumentoTributario'
import SEFooterResumen from './Components/ResumenFactura/SEFooterResumen'
import SEFooterFinalizacion from './Components/ResumenFactura/SEFooterFinalizacion'
import {useSelector} from 'react-redux'
import {State} from '../../reducers'
import {useHistory} from 'react-router'

const ResumenFacturaSujetoExcluido = () => {
  const history = useHistory()
  const facturaEmitida = useSelector((state: State) => state.sujetoExcluido.facturaEmitda)
  const arrayP = useSelector((state: State) => state.sujetoExcluido.arrayProductos)

  useEffect(() => {
    if (arrayP.length === 0) history.push('/otros-documentos/sujeto-excluido/formulario')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <SEModalsResumenControl />
      <SEEncabezado url='/otros-documentos/sujeto-excluido/formulario' />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell' style={{minHeight: '100vh'}}>
          <div className='card'><SEDocumentoTributario /></div>
        </div>
        {!facturaEmitida ? <SEFooterResumen /> : <SEFooterFinalizacion />}
      </div>
    </>
  )
}

export default ResumenFacturaSujetoExcluido
